import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">蜜桃视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              专注甜蜜生活方式的创意短视频平台，汇聚美食、旅行、时尚、萌宠等多元内容，让每一帧都充满桃气与活力。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-reactjs-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/meishi" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">美食</Link></li>
              <li><Link to="/category/lvxing" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">旅行</Link></li>
              <li><Link to="/category/shishang" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">时尚</Link></li>
              <li><Link to="/category/mengchong" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">萌宠</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">品牌故事</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">发展历程</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">创作者入驻</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">帮助中心</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">hello@mitao-video.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">北京市朝阳区望京SOHO T1 12层</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 蜜桃视频 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}